// ImaginaryAnimalFace
import React from 'react';
import ImaginaryAnimalFace from 'views/ImaginaryAnimalFace';

const IndexPage = () => {
  return <ImaginaryAnimalFace />;
};

export default IndexPage;
